import { toast } from "react-toastify";
import { apiSlice } from ".";

export const filesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation({
      query: ({ image, imageType, tag }) => ({
        url: `/AALuploader/AALuploadfiles?A=${imageType}&tag=${tag}`,
        method: "POST",
        body: image,
      }),
      async onQueryStarted(args, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Uploading Image",
          success: "Image Uploaded",
          error: "Error Uploading Image",
        });
      },
    }),
    uploadPdf: builder.mutation({
      query: ({ formData, propertyId, pdfType }) => ({
        url: `/PDFUploader/UploadPDF?ver=${pdfType}&propid=${propertyId}`,
        method: "POST",
        body: formData,
      }),

      async onQueryStarted(args, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Generating Pdf",
          success: "Pdf Generated",
          error: "Error Generating Pdf",
        });
      },
      invalidatesTags: ["Properties"],
    }),
    regeneratePDF: builder.mutation({
      query: (propertyId) => ({
        url: `/pdfGenerator/GeneratePropertyPDF?propertyId=${propertyId}`,
        method: "GET",
      }),
      async onQueryStarted(args, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Generating Pdf",
          success: "Pdf Generated",
          error: "Error Generating Pdf",
        });
      },
    }),
  }),
});

export const {
  useUploadImageMutation,
  useUploadPdfMutation,
  useRegeneratePDFMutation,
} = filesApi;
